export default null;



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/Snackbar/initialState.js